/* eslint no-console: 0 */
/* global axios */
import ApiClient from '../ApiClient';

export const buildCreatePayload = ({
  message,
  isPrivate,
  contentAttributes,
  echoId,
  files,
  ccEmails = '',
  bccEmails = '',
  toEmails = '',
  templateParams,
  attachmentFileTypes = [],
  whatsappConsentOverride = false,
  whatsappConsentOverrideReason = '',
}) => {
  let payload;
  if (files && files.length !== 0) {
    payload = new FormData();
    if (message) {
      payload.append('content', message);
    }
    files.forEach(file => {
      payload.append('attachments[]', file);
    });
    attachmentFileTypes.forEach(fileType => {
      payload.append('attachment_file_types[]', fileType);
    });
    payload.append('private', isPrivate);
    payload.append('echo_id', echoId);
    payload.append('cc_emails', ccEmails);
    payload.append('bcc_emails', bccEmails);

    if (toEmails) {
      payload.append('to_emails', toEmails);
    }
    if (contentAttributes) {
      payload.append('content_attributes', JSON.stringify(contentAttributes));
    }
    payload.append('whatsapp_consent_override', whatsappConsentOverride);
    payload.append(
      'whatsapp_consent_override_reason',
      whatsappConsentOverrideReason
    );
  } else {
    payload = {
      content: message,
      private: isPrivate,
      echo_id: echoId,
      content_attributes: contentAttributes,
      cc_emails: ccEmails,
      bcc_emails: bccEmails,
      to_emails: toEmails,
      template_params: templateParams,
      attachment_file_types: attachmentFileTypes,
      whatsapp_consent_override: whatsappConsentOverride,
      whatsapp_consent_override_reason: whatsappConsentOverrideReason,
    };
  }
  return payload;
};

class MessageApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  create({
    conversationId,
    message,
    private: isPrivate,
    contentAttributes,
    echo_id: echoId,
    files,
    ccEmails = '',
    bccEmails = '',
    toEmails = '',
    templateParams,
    attachmentFileTypes = [],
    whatsappConsentOverride = false,
    whatsappConsentOverrideReason = '',
  }) {
    return axios({
      method: 'post',
      url: `${this.url}/${conversationId}/messages`,
      data: buildCreatePayload({
        message,
        isPrivate,
        contentAttributes,
        echoId,
        files,
        ccEmails,
        bccEmails,
        toEmails,
        templateParams,
        attachmentFileTypes,
        whatsappConsentOverride,
        whatsappConsentOverrideReason,
      }),
    });
  }

  delete(conversationID, messageId) {
    return axios.delete(`${this.url}/${conversationID}/messages/${messageId}`);
  }

  retry(conversationID, messageId) {
    return axios.post(
      `${this.url}/${conversationID}/messages/${messageId}/retry`
    );
  }

  getPreviousMessages({ conversationId, after, before }) {
    const params = { before };
    if (after && Number(after) !== Number(before)) {
      params.after = after;
    }
    return axios.get(`${this.url}/${conversationId}/messages`, { params });
  }

  translateMessage(conversationId, messageId, targetLanguage) {
    return axios.post(
      `${this.url}/${conversationId}/messages/${messageId}/translate`,
      {
        target_language: targetLanguage,
      }
    );
  }

  react(conversationId, messageId, emoji) {
    return axios.post(
      `${this.url}/${conversationId}/messages/${messageId}/react`,
      { emoji }
    );
  }

  updateOrderStatus(
    conversationId,
    messageId,
    referenceId,
    orderStatus,
    paymentStatus = null
  ) {
    return axios.post(
      `${this.url}/${conversationId}/messages/${messageId}/order_status`,
      {
        reference_id: referenceId,
        order_status: orderStatus,
        payment_status: paymentStatus,
      }
    );
  }
}

export default new MessageApi();
